<template>
  <el-dialog title="推送设置" :visible.sync="dialogVisible" :close-on-click-modal="false" width="60%" center @close="handleClose">
    <div class="push-dialog">
      <el-form label-width="90px" label-position="left" class="push-form">
        <el-form-item label="推送时间：">
          <el-radio-group v-model="form.sendTime">
            <el-radio label="now">立即发放</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="推送人群：">
          <div class="option-row">
            <el-radio label="single" v-model="form.sendTarget">单个客户</el-radio>
            <el-input
              class="phone-input"
              size="small"
              v-model.trim="form.singleMobile"
              maxlength="11"
              placeholder="请输入手机号"
              :disabled="form.sendTarget !== 'single'"
            >
              <template slot="append">
                <el-button :loading="verifying" :disabled="form.sendTarget !== 'single'" @click="verifyMobile"> 验证 </el-button>
              </template>
            </el-input>
          </div>
          <p v-if="form.sendTarget === 'single' && verifyMessage" class="verify-message" :class="verifyStatus">
            {{ verifyMessage }}
          </p>
          <div class="option-row">
            <el-radio label="import" v-model="form.sendTarget">导入名单</el-radio>
            <el-button type="text"> <a href="/excel/template_coupon.xlsx" style="font-size: 12px"> 下载模板 </a></el-button>
            <el-button type="text" @click="handleViewList">查看名单</el-button>
            <el-upload
              ref="importUploader"
              class="upload-demo"
              action="#"
              accept=".xlsx"
              :auto-upload="false"
              :show-file-list="false"
              :file-list="uploadFileList"
              :disabled="form.sendTarget !== 'import'"
              :before-upload="beforeUpload"
              :on-change="handleUploadChange"
            >
              <el-button size="mini" type="primary" class="import-btn" :disabled="form.sendTarget !== 'import'"> 导入 </el-button>
            </el-upload>
          </div>
          <p class="tips">xls、xlsx、csv 格式，单次最多导入 5000 条</p>
        </el-form-item>
      </el-form>
    </div>
    <div v-if="selectedContacts.length" class="custom-slot">
      <el-table row-key="user_uuid" :data="selectedContacts" border height="360" :cell-style="{ padding: '4px 0' }">
        <el-table-column prop="mobile" label="手机号" width="140" />
        <el-table-column prop="nick_name" label="昵称" />
        <el-table-column prop="issue_date" label="发放时间" min-width="160" show-overflow-tooltip />
        <el-table-column prop="is_issued" label="是否已使用" width="120" align="center">
          <template slot-scope="scope">
            <span :class="scope.row.is_issued === 'N' ? 'valid' : 'invalid'">
              {{ scope.row.is_issued === "N" ? "未使用" : "已使用" }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="!selectedContacts.length" class="empty-view">暂无数据</div>
    </div>
    <div slot="footer" class="dialog-footer">
      <slot name="footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" :loading="submitting" @click="handleConfirm"> 确 定 </el-button>
      </slot>
    </div>

    <import-data-dialog ref="importDialog" @confirm="handleImportDialogConfirm" />
  </el-dialog>
</template>

<script>
  import ImportDataDialog from "./import-data-dialog.vue";

  export default {
    name: "CustomerDialog",
    components: {
      ImportDataDialog,
    },
    data() {
      return {
        dialogVisible: false,
        form: {
          sendTime: "now",
          sendTarget: "single",
          singleMobile: "",
        },
        verifying: false,
        verifyStatus: "",
        verifyMessage: "",
        selectedContacts: [],
        submitting: false,
        downloadingTemplate: false,
        coupon_uuid: "",
        uploadFileList: [],
        uploadingImport: false,
      };
    },
    watch: {
      "form.sendTarget"(val) {
        if (val !== "import") {
          this.resetImportSelection();
          this.uploadFileList = [];
        }
        if (val !== "single") {
          this.verifyMessage = "";
          this.verifyStatus = "";
        }
        this.selectedContacts = [];
      },
    },
    methods: {
      requestApi(data, path, method) {
        return this.axios({
          method: method || "post", //请求方法
          data,
          headers: {
            "Content-Type": "application/json",
            "X-Access-Token": this.storage.get("__token"),
            Authorization: `Bearer ${this.storage.get("__token")}`,
          },
          url: ` https://time.api.boyalife.cn/v1/cms/${path}`,
        })
          .then((res) => {
            if (res.data.code !== 200) {
              return Promise.reject(res);
            }
            return res;
          })
          .then((res) => res.data)
          .catch((err) => this.$message.error(err.response.data.error.message));
      },
      beforeUpload(file) {
        if (this.form.sendTarget !== "import") {
          this.$message.info("请先选择“导入文件”");
          return false;
        }
        return true;
      },
      transformImportRows(rows = []) {
        return rows
          .filter((item) => item && item.mobile)
          .map((item, index) => {
            const issuedFlag = item.is_issued || (item.valid === false ? "Y" : "N");
            return {
              coupon_uuid: item.coupon_uuid,
              mobile: item.mobile,
              nick_name: item.nick_name || item.name || `客户${index + 1}`,
              user_uuid: item.user_uuid || "",
              is_issued: issuedFlag,
              issue_date: item.issue_date || "",
              valid: issuedFlag !== "Y",
            };
          });
      },
      uploadImportFile(file) {
        if (!file) return;
        const importDialog = this.$refs.importDialog;
        if (importDialog) {
          importDialog.open({ data: [], loading: true });
        }
        const formData = new FormData();
        formData.append("file", file);
        formData.append("coupon_uuid", this.coupon_uuid || "");
        this.uploadingImport = true;
        return this.requestApi(formData, "coupon/checkExcelData")
          .then((res) => {
            const rows = (res && res.result) || [];
            const normalized = this.transformImportRows(rows);
            if (importDialog) {
              importDialog.setData(normalized);
              importDialog.setLoading(false);
            }
            this.selectedContacts = normalized;
            this.$emit("import", normalized);
            this.$message.success("导入完成");
          })
          .catch((error) => {
            const message = (error && error.message) || "导入失败";
            this.$message.error(message);
            if (importDialog) {
              importDialog.setData([]);
              importDialog.setLoading(false);
            }
          })
          .finally(() => {
            this.uploadingImport = false;
          });
      },
      handleUploadChange(file, fileList) {
        this.uploadFileList = fileList;
        const current = fileList.length > 0 ? fileList[fileList.length - 1] : null;
        if (!current || !current.raw) return;
        if (this.beforeUpload(current.raw) === false) {
          this.uploadFileList = [];
          return;
        }
        this.uploadImportFile(current.raw);
      },
      open(couponId = "") {
        this.coupon_uuid = couponId;
        this.selectedContacts = [];
        this.dialogVisible = true;
      },
      verifyMobile() {
        if (this.form.sendTarget !== "single") return;
        if (!this.form.singleMobile) {
          this.$message.warning("请先输入手机号");
          return;
        }
        if (!/^1\d{10}$/.test(this.form.singleMobile)) {
          this.verifyStatus = "invalid";
          this.verifyMessage = "手机号格式不正确";
          return;
        }
        const params = {
          coupon_uuid: this.coupon_uuid,
          mobile: this.form.singleMobile,
        };
        this.verifying = true;
        this.requestApi(params, "coupon/checkMobileData")
          .then((res) => {
            this.selectedContacts = this.transformImportRows(res.result || []);
          })
          .finally(() => (this.verifying = false));
      },
      handleViewList() {
        const importDialog = this.$refs.importDialog;
        if (!importDialog) return;
        importDialog.open({
          data: this.selectedContacts,
          loading: false,
          title: "已选名单",
          confirmText: "确定",
          width: "720px",
        });
        this.$emit("view-list", this.selectedContacts);
      },
      handleImportDialogConfirm(rows, done) {
        if (!rows || !rows.length) {
          done && done(false);
          return;
        }
        this.selectedContacts = rows.map((item) => ({
          coupon_uuid: item.coupon_uuid,
          mobile: item.mobile,
          nick_name: item.nick_name || item.name,
          user_uuid: item.user_uuid,
          is_issued: item.is_issued,
          issue_date: item.issue_date,
          valid: item.valid,
        }));
      },
      resetImportSelection() {
        const importDialog = this.$refs.importDialog;
        importDialog && importDialog.clearSelection && importDialog.clearSelection();
        this.uploadFileList = [];
        const uploader = this.$refs.importUploader;
        uploader && uploader.clearFiles && uploader.clearFiles();
      },
      handleConfirm() {
        if (!this.selectedContacts.length) {
          this.$message.warning("缺少客户信息");
          return;
        }
        const params = {
          coupon_uuid: this.coupon_uuid,
          data: this.selectedContacts.map(({ user_uuid, coupon_uuid }) => {
            return { user_uuid, coupon_uuid };
          }),
        };
        this.submitting = true;
        this.requestApi(params, "coupon/excelDataConfirm")
          .then((res) => {
            this.handleClose();
            this.$emit("success", res);
            this.$message.success(res.message || "操作成功");
          })
          .finally(() => (this.submitting = false));
      },
      handleCancel() {
        this.handleClose();
      },
      handleClose() {
        this.dialogVisible = false;
      },
    },
  };
</script>

<style scoped>
  .push-dialog {
    padding: 10px 0 0;
  }

  .push-form ::v-deep .el-form-item {
    margin-bottom: 18px;
  }

  .option-row {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    color: #303133;
    font-size: 14px;
  }

  .option-row:last-of-type {
    margin-bottom: 0;
  }

  .phone-input {
    width: 240px;
    margin-left: 12px;
  }

  .verify-btn {
    padding: 0;
  }

  .verify-message {
    margin: 0 0 10px 104px;
    font-size: 12px;
  }

  .verify-message.valid {
    color: #67c23a;
  }

  .verify-message.invalid {
    color: #f56c6c;
  }

  .import-btn {
    margin: 0 12px;
  }

  .tips {
    margin: 0 0 12px 24px;
    color: #000;
    font-size: 12px;
  }

  .selected-list {
    margin: 0 0 10px 24px;
    background: #f8f9fb;
    border-radius: 4px;
    padding: 10px 12px;
  }

  .selected-title {
    font-size: 12px;
    color: #606266;
    margin-bottom: 6px;
  }

  .selected-tags {
    display: flex;
    flex-wrap: wrap;
  }

  .selected-tag {
    margin: 4px 8px 0 0;
  }

  .dialog-footer {
    text-align: center;
    padding-bottom: 10px;
  }

  .dialog-footer .el-button {
    min-width: 110px;
  }

  .valid {
    color: #67c23a;
  }

  .invalid {
    color: #f56c6c;
  }

  .custom-slot {
    padding: 10px 0;
  }

  .empty-view {
    text-align: center;
    padding: 30px 0;
    color: #909399;
  }
</style>
